import { EventsQueueState } from "./types";

export function getDefaultState(): EventsQueueState {
	return {
		AlarmQueueFilters: [],
		AlarmQueueFilterIDs: [],
		AllEvents: [],
		FilteredEvents: [],
		CurrentSort: {
			sort: 0,
			desc: false,
			changed: false,
			reversed: false
		},
		AlarmActiveFilter: {
			filterId: -1,
			regionId: null
		},
		EventsLastUpdated: 0,
		HoverEvent: null,
		DisplayedEvent: null,
		NewFilterModalShown: false,
		ManualPatrolShown: false,
		ManualActionShown: false,
		ActivityLogShown: false,
		SiteTree: [],
		ChangedTreeNodes: [],
		selectedGroups: [],
		treeSelectedGroup: {},
		searchSelectedGroup: {},
		queueMapBounds: null,
		activeAlarmCount: 0,
		eventCountsByType: {
			parked: 0,
			patrols: 0,
			inProcess: 0,
			onTest: 0,
			system: 0
		},
		eventQueueGetOverride: null,
		processingError: null,
		userZone: {
			groupID: 0,
			parentGroupID: 0,
			title: "",
			timeZoneID: 0,
			selected: false
		},
		lastEventHandled: null,
		RoutingGroups: [],
		AlarmTags: [],
		ServerEventTypes: [],
		filteredServerEventTypes: null,
		HandlingEvent: false,
		advancedTreeSearchCancelToken: null,
		JoiningEventID: null,
		TourNoteRequired: false,
		hideMapFlag: false,
		BulkHandleShown: false,
		AllAlarmsSelected: false,
		AllAlarmsClicked: false,
		EndEventsDialogShown: false,
		SelectedAlarms: [],
		RefreshQueue: false,
		linkedTasksModal: {
			visible: false,
			event: null,
			responsesMetadata: {}
		},
		SystemEventRecords: [],
		HighPriorityState: {
			LoadingIgnore: false,
			LoadingAccept: false,
			Threshold: 1000,
			IgnoredEventIds: []
		},
		callQueue: [],
		callClients: [],
		showIntercomModal: false,
		callWaitingPrefs: []
	};
}
